import DatePicker from "components/Form/DatePicker";
import { ControlInputFieldProps } from "components/Form/typings";
import { PropsWithChildren } from "react";
import FormField from "./FormField";

export interface DatePickerFieldProps extends ControlInputFieldProps, PropsWithChildren {
  options?: OptionType<Date>[];
  isClearable?: boolean;
  minDate?: Date;
  defaultIsOpen?: boolean;
  usePortal?: boolean;
  preserveTime?: boolean;
  receiveDate?: boolean;
  dateFormat?: string;
  onDateChange?: (date: Date | undefined) => void;
  triggerButtonProps?: object;
  includeIcon?: boolean;
}

export default function DatePickerField({
  name,
  label,
  helperText,
  control,
  errors,
  defaultValue,
  disabled,
  required,
  isClearable,
  minDate,
  defaultIsOpen,
  receiveDate,
  usePortal,
  preserveTime,
  variant,
  dateFormat,
  onDateChange,
  formFieldProps = {},
  triggerButtonProps = {},
  includeIcon,
  children,
  ...rest
}: DatePickerFieldProps) {
  const formVariant = variant;

  return (
    <FormField
      name={name}
      label={label}
      errors={errors}
      helperText={helperText}
      required={required}
      variant={formVariant}
      className="chakra-datepicker-wrapper"
      {...formFieldProps}
    >
      <DatePicker
        name={name}
        control={control}
        rules={required ? { required: true } : {}}
        disabled={disabled}
        defaultValue={defaultValue}
        isClearable={isClearable}
        minDate={minDate}
        defaultIsOpen={defaultIsOpen}
        usePortal={usePortal}
        preserveTime={preserveTime}
        dateFormat={dateFormat}
        receiveDate={receiveDate}
        onDateChange={onDateChange}
        variant={formVariant}
        includeIcon={includeIcon}
        triggerButtonProps={triggerButtonProps}
        {...rest}
      >
        {children}
      </DatePicker>
    </FormField>
  );
}
